import { action, makeObservable, observable } from 'mobx';

class ProductCategoryStore {
    constructor() {
        makeObservable(this)
    }

    @observable loadingItemStatus: boolean = false;
    @action setLoadingItemStatus(status: boolean) {
        this.loadingItemStatus = status;
    }

    // ProductCategories
    @observable productCategories = {}
    @action setProductCategories(productCategories: any) {
        this.productCategories = productCategories;
    }

    @action addProductCategory(productCategoryId: number, productCategoryData: any) {
        this.productCategories[productCategoryId] = productCategoryData;
    }

    @action addProductCategoryItem(productCategoryId: number, productId: number, productItem: any) {
        this.productCategories[productCategoryId].content[productId] = productItem;
    }

    @action updateProductCategory(productCategoryId: number, productCategoryData: any) {
        this.productCategories[productCategoryId] = productCategoryData;
    }

    @action deleteProductCategory(productCategoryId: number) {
        delete this.productCategories[productCategoryId];
    }

    @action setPaginationData(categoryId: number, page: number, pageCount: number) {
        this.productCategories[categoryId] = {
            ...this.productCategories[categoryId],
            page,
            pageCount,
        };
    }
    // ProductCategories
}

const store = new ProductCategoryStore();

export default store;